import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/checkpoint/engage-1.webp")